import { XauditModel } from "src/app/models/xaudit.model";
import { NotesToFrontAutoFillDetail } from "./notes-to-front-autofill-detail.model";

export default class NotesToFrontAutoFill extends XauditModel {
    AutoFillID: string;
	Name: string;
	ApptCount:number
	TDOCID:number;
	isDefault: boolean;
    cfgNoteToFrontAutoFillDetails: NotesToFrontAutoFillDetail[];
}
